// extracted by mini-css-extract-plugin
export default {"root":"WnnzlaSXPWASA_OUhh6w","label":"FNWFIR7yBUsDgK2WGrP1"};